module.exports = __webpack_public_path__ + "static/media/PATS_2-768w.ad72f56c.webp";